// File: src/utils/authHelpers.js

import { jwtDecode } from 'jwt-decode';

export const getUserIdFromStorageOrToken = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;

    const userData = localStorage.getItem('userData');
    if (userData) {
      const parsed = JSON.parse(userData);
      if (parsed._id || parsed.id) {
        return parsed._id || parsed.id;
      }
    }

    const decoded = jwtDecode(token);
    if (decoded?.userId) {
      return decoded.userId;
    }

    return null;
  } catch (error) {
    console.error('Error getting userId:', error);
    return null;
  }
};
